export default {
    REMOTE: 'remote',
    LOCAL: 'local',
    SYSTEM: 'system',
};
